/* eslint-disable no-redeclare */
import {
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const UpdateProspectAnalyticsIdentifierParameters = z.object({
  userId: HealthcareUserId,
  sessionId: HealthcareSessionId,
  domainSessionId: DomainSessionId,
  domainUserId: DomainUserId,
});

export type UpdateProspectAnalyticsIdentifierParameters = z.infer<
  typeof UpdateProspectAnalyticsIdentifierParameters
>;
